module.exports = __webpack_public_path__ + "static/img/gpt56.0f22378f.png";